export function asCockpitError(reason: unknown): Error {
  return reason instanceof Error ? reason : new Error(String(reason));
}

export function isCockpitForbidden(error: Error): boolean {
  const value = error as Error & { status?: number; code?: string };
  return value.status === 403 || value.code?.includes('FORBIDDEN') === true;
}
